import Cookies from 'js-cookie';
import Script from 'next/script';
import type { FC } from 'react';
import { useEffect } from 'react';
import semverGte from 'semver/functions/gte';

import { MOBILE_APP_PLATFORM_IOS } from '@/utils/app';

import type { Props } from './types';

export const TeadAds: FC<Props> = ({
  isApp,
  tagId,
  teadsId,
}) => {
  useEffect(() => {
    async function teadAdsLoadScripts(scriptUrls: string[]) {
      if (typeof document === 'undefined') {
        return;
      }

      function createScript(scriptUrl: string) {
        return new Promise((resolve) => {
          if (!teadAdsLoadScripts.loaded.has(scriptUrl)) {
            const script = document.createElement('script');

            script.onload = resolve;
            script.src = scriptUrl;
            script.className = 'teads';
            script.type = 'text/javascript';
            script.async = true;
            document.head.appendChild(script);
          }
        });
      }
      const teadsAdsProcessCenter = [];

      for (const scriptUrl of scriptUrls) {
        teadsAdsProcessCenter.push(createScript(scriptUrl));
      }
      await Promise.all(teadsAdsProcessCenter);
    }
    teadAdsLoadScripts.loaded = new Set();

    async function load() {
      await teadAdsLoadScripts([`//a.teads.tv/page/${teadsId}/tag`]);

      window.teads_analytics = window.teads_analytics || {};
      window.teads_analytics.analytics_tag_id = tagId;

      window.teads_analytics.share = window.teads_analytics.share
      || function anonymous() {
        (window.teads_analytics.shared_data = window.teads_analytics.shared_data
        // eslint-disable-next-line prefer-rest-params
        || []).push(arguments);
      };
    }

    load();
  }, [tagId, teadsId]);

  const appVersion = Cookies.get('appversion');

  return (
    <>
      {isApp
      && appVersion
      && semverGte(appVersion, '2.1.2')
      && Cookies.get('loadFrom') === MOBILE_APP_PLATFORM_IOS
        ? (
          <>
            <div id="teads-placement-slot-mobile-app" />
            <li
              id="nc_imbedding"
              style={{ display: 'none' }} />
          </>
        )
        : (
          <>
            <div id="teadsads-placement-listing" />
            <li
              id="nc_imbedding"
              style={{ display: 'none' }} />
          </>
        )}
      <Script
        data-id={`${teadsId}-teads-scripts`}
        src="https://a.teads.tv/analytics/tag.js" />
      <Script
        data-id={`${teadsId}-teads-scripts`}
        src="https://a.teads.tv/media/format/v3/teads-format.min.js" />
    </>
  );
};
